import { Eye, X } from 'lucide-react';
import { useSimulatedRole } from '@/hooks/useSimulatedRole';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '@/contexts/i18nContext';

export default function SimulationBanner() {
  const { simulatedRole, clearSimulation, isSimulating } = useSimulatedRole();
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!isSimulating || !simulatedRole) return null;

  const handleExit = () => {
    clearSimulation();
    navigate('/dashboard');
  };

  // Get translated role name
  const getRoleName = () => {
    switch (simulatedRole) {
      case 'god_mode': return t('roleSimulator.godMode');
      case 'admin': return t('roleSimulator.admin');
      case 'sovereign': return t('roleSimulator.homeowner');
      case 'demi_user': return t('roleSimulator.guest');
      default: return simulatedRole;
    }
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-amber-950 py-2 px-4">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Eye className="w-4 h-4" />
          <span className="text-sm font-medium">
            {t('simulation.simulating')}: <strong>{getRoleName()}</strong>
          </span>
        </div>
        <button
          onClick={handleExit}
          className="flex items-center gap-1.5 px-3 py-1 bg-amber-600/30 hover:bg-amber-600/50 rounded-lg text-sm font-medium transition-colors"
        >
          <X className="w-4 h-4" />
          {t('simulation.exit')}
        </button>
      </div>
    </div>
  );
}
